export const OTP_VALIDATION = {
    otp_code: {
        required: 'OTP wajib diisi',
        minimum: {
            value: 4,
            message: 'Mohon lengkapi OTP',
        },
    },
}
